import store from '@/store'
// 首位补0
function prefixInteger (num, length) {
  return (Array(length).join('0') + num).slice(-length)
}
class Util {
  // 创建GUID
  setGUID () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }
  timestampToTime (timestamp) {
    const date = timestamp ? new Date(timestamp) : new Date()// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear()
    const M = date.getMonth() + 1
    const D = date.getDate()
    const h = date.getHours()
    const m = date.getMinutes()
    const s = date.getSeconds()
    const timeObj = {
      year: Y,
      month: prefixInteger(M, 2),
      day: prefixInteger(D, 2),
      hour: prefixInteger(h, 2),
      minute: prefixInteger(m, 2),
      second: prefixInteger(s, 2)
    }
    return timeObj
  }
  // aliOsUrl = (value) => {
  //   let result
  //   if (!value) return false
  //   if (value.match(/http/gi) || value.indexOf('data:image') > -1 || (process.env.NODE_ENV === 'development' && value.indexOf('static') > -1)) {
  //     result = value
  //   } else {
  //     result = 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com' + value
  //   }
  //   return result
  // }
  aliOsUrl (value) {
    let result
    if (!value) return false
    if (value.match(/http/gi) || value.indexOf('data:image') > -1 || (process.env.NODE_ENV === 'development' && value.indexOf('static') > -1)) {
      result = value
    } else if (process.env.NODE_ENV === 'production') {
      result = 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/' + value
    } else {
      // result = 'https://172.16.121.28/' + value
      result = 'https://www.test-kmaxosscloud.com/' + value
    }
    return result
  }
  aliOsUrlModel (value) {
    let result
    if (!value) return false
    if (value.match(/http/gi) || value.indexOf('data:image') > -1 || (process.env.NODE_ENV === 'development' && value.indexOf('static') > -1)) {
      result = value
    } else if (process.env.NODE_ENV === 'production') {
      result = 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/' + value
    } else {
      result = 'https://partybuildingplatformtest.oss-cn-shanghai.aliyuncs.com/' + value
      //  result = 'https://static-test.kmaxredcloud.com/' + value
    }
    return result
  }
  // 设置底部tabs最后离开的滚动条位置
  setTabsLeaveSite (route, routeSite) {
    const TabsLeaveSite = store.getters.TabsLeaveSite
    const routeIndex = TabsLeaveSite.findIndex(item => { return item.router === route })
    if (routeIndex !== -1) {
      TabsLeaveSite[routeIndex].site = routeSite
      store.commit('SET_TABS_LEAVE_SITE', TabsLeaveSite)
    }
  }
}
export default new Util()
